'use client';

import { IntlProvider } from 'next-intl';
import { ReactNode } from 'react';

import { messages } from '@/shared/config/i18n';
import { LocaleType } from '@/shared/lib/i18n';

type I18nProviderProps = {
  children: ReactNode;
  locale: LocaleType;
};

export function I18nProvider({ children, locale }: I18nProviderProps) {
  return (
    <IntlProvider messages={messages[locale]} locale={locale} timeZone="Asia/Seoul">
      {children}
    </IntlProvider>
  );
}
